module.exports = {
  "dataLayerSitePrefix": "public-uk"
};